var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAwayEarly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 7.125L0.835938 1.33594C0.886719 0.929688 1.24219 0.625 1.64844 0.625H5.91406C6.29492 0.625 6.625 0.955078 6.625 1.33594C6.625 1.41211 6.59961 1.48828 6.57422 1.56445L5.40625 4.6875H8.93555C9.44336 4.6875 9.875 5.11914 9.875 5.62695C9.875 5.83008 9.79883 6.00781 9.69727 6.16016L4.82227 13.2949C4.66992 13.498 4.41602 13.6504 4.16211 13.6504H4.08594C3.67969 13.6504 3.375 13.3203 3.375 12.9141C3.375 12.8633 3.375 12.7871 3.40039 12.7363L4.59375 7.9375H0.9375C0.480469 7.9375 0.125 7.58203 0.125 7.125Z",
    fill: "currentColor"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8926_19510",
    x1: 5,
    y1: 2,
    x2: 5,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5C44D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A402"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwayEarly);
export default ForwardRef;